/** MUI renders dialogs and menus in <body>, which is hidden while the viewer is fullscreen. */
export const exitReportFullscreen = () => {
  if (document.fullscreenElement) document.exitFullscreen?.();
};

/** Container for menus opened from the viewer, so they stay visible in fullscreen. */
export const getReportOverlayContainer = () => document.fullscreenElement ?? document.body;
